import { ParentAssigner, Root } from "../../../output/assets/objects/parent-assigner.js";

class ThreeParentAssigner extends ParentAssigner {
    constructor(rootObject) {
        super();

        this._rootObject = rootObject;
    }

    link(parent, child) {
        if (parent === Root) {
            parent = this._rootObject;
        }

        parent.add(child);
    }

    unlink(parent, child) {
        if (parent === Root) {
            parent = this._rootObject;
        }

        parent.remove(child);
    }
}

export default ThreeParentAssigner;
